import React, { useState } from 'react';

import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import Axios from 'axios';
import { cancelPromises, getCancelToken, getSource } from '../../utils/AccountsAPI';
import { deleteFile, getFile, postFile } from './FileAPI';
import { toastError } from '../../utils/Functions';

registerPlugin(FilePondPluginImagePreview, FilePondPluginImageExifOrientation, FilePondPluginFileValidateType);

export default function FilePondWrapper(props) {
  const [files, setFiles] = useState<any[]>([]);
  const [pond, setPond] = useState<any>([]);
  const source = getSource();

  const handleInit = () => {
    console.log('FilePond instance has initialised', pond);
  };

  const processFile = (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
    const progressFunc = (e) => {
      progress(e.lengthComputable, e.loaded, e.total);
    };

    postFile(file, file.name, progressFunc, getCancelToken(source))
      .then((response) => {
        if (props.addFile) props.addFile(response);
        load(response.id);
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          error(err?.response?.message ?? err?.message);
          toastError(props.toast, err);
        }
      });

    return {
      abort: () => {
        cancelPromises(source);
        abort();
      },
    };
  };

  const removeFile = (fileId, load, error) => {
    deleteFile(fileId).then(
      (response) => {
        if (props.removeFile) props.removeFile(fileId);
        load();
      },
      (err) => {
        error(err.response ? err.response.message : err.message);
        toastError(props.toast, err);
      }
    );
  };

  const fetchFile = (fileSource, load, error, progress, abort, headers) => {
    const progressFunc = (e) => {
      progress(e.lengthComputable, e.loaded, e.total);
    };

    getFile(fileSource, progressFunc, getCancelToken(source)).then(
      (response) => {
        headers(response.headers);
        load(response.data);
      },
      (err) => {
        if (!Axios.isCancel(err)) {
          error(err?.response?.message ?? err?.message);
          toastError(props.toast, err);
        }
      }
    );

    return {
      abort: () => {
        cancelPromises(source);
        abort();
      },
    };
  };

  return (
    <FilePond
      style={{ paddingTop: '16px' }}
      ref={(ref) => setPond(ref)}
      files={files}
      oninit={() => handleInit()}
      onupdatefiles={(fileItems) => {
        setFiles(fileItems.map((fileItem) => fileItem.file));
      }}
      server={{
        process: processFile,
        revert: removeFile,
        remove: removeFile,
        fetch: fetchFile,
      }}
      labelIdle={props.label ?? 'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'}
      imagePreviewMaxFileSize='1MB'
      imagePreviewMaxHeight='100'
      acceptedFileTypes={['image/*', 'application/pdf']}
      type='file'
    />
  );
}
